// extracted by mini-css-extract-plugin
export var optionGrid = "_av-7";
export var optionList = "_av-6";
export var questionsBlock = "_av-9";
export var spacer = "_av-5";
export var stepCenteredContent = "_av-3";
export var stepInner = "_av-0";
export var stepInnerFullWidth = "_av-1";
export var stepInnerLockScroll = "_av-2";
export var stepTransitionFrame = "_av-4";
export var welcomeBlock = "_av-8";